/* ============================================================
   OSMANLI DOĞAL TAŞ — Enneagram model motoru

   KAYNAK DOĞRULAMASI (Riso-Hudson / Enneagram Institute, Chestnut):
   · Stres (dezentegrasyon) yönü : 1→4→2→8→5→7→1  ve  9→6→3→9
   · Büyüme (bütünleşme) yönü    : 1→7→5→8→2→4→1  ve  9→3→6→9
   · Merkezler   : Beden/Öfke 8-9-1 · Kalp/Utanç 2-3-4 · Zihin/Korku 5-6-7
   · Hornevian   : Atılgan 3-7-8 · Uyumlu 1-2-6 · Geri çekilen 4-5-9
   · Harmonik    : Olumlu bakış 2-7-9 · Yetkinlik 1-3-5 · Tepkisel 4-6-8
   · Karşı-tipler: SP1 SP2 SP3 SP4 SO5 SX6 SP7 SO8 SO9 (Chestnut 2013)

   PUANLAMA NOTU: ham toplam KULLANILMAZ. Likert ölçekte kimi kişi her şeye
   yüksek, kimi düşük puan verir (acquiescence bias) — ham toplamda cömert
   cevaplayanın bütün tipleri yükselir ve ayrım kaybolur. Bu yüzden puanlar
   kişinin KENDİ ortalaması ve std'sine göre z-skora çevrilir (ipsatif).
   ============================================================ */
(function (g) {
  'use strict';

  /* ---------------------------------------------------------- sabit yapı */

  /* Stres ve büyüme okları — yukarıdaki iki döngüden türetildi */
  var STRES  = { 1: 4, 4: 2, 2: 8, 8: 5, 5: 7, 7: 1, 9: 6, 6: 3, 3: 9 };
  var BUYUME = { 1: 7, 7: 5, 5: 8, 8: 2, 2: 4, 4: 1, 9: 3, 3: 6, 6: 9 };

  var MERKEZ = {
    beden: { tipler: [8, 9, 1], ad: 'Beden', duygu: 'Öfke',  organ: 'içgüdü' },
    kalp:  { tipler: [2, 3, 4], ad: 'Kalp',  duygu: 'Utanç', organ: 'duygu' },
    zihin: { tipler: [5, 6, 7], ad: 'Zihin', duygu: 'Korku', organ: 'düşünce' }
  };
  var HORNEVIAN = {
    atilgan:  { tipler: [3, 7, 8], ad: 'Atılgan' },
    uyumlu:   { tipler: [1, 2, 6], ad: 'Uyumlu' },
    cekilen:  { tipler: [4, 5, 9], ad: 'Geri Çekilen' }
  };
  var HARMONIK = {
    olumlu:   { tipler: [2, 7, 9], ad: 'Olumlu Bakış' },
    yetkin:   { tipler: [1, 3, 5], ad: 'Yetkinlik' },
    tepkisel: { tipler: [4, 6, 8], ad: 'Tepkisel' }
  };
  /* Karşı-tip: tipin diğer iki alt tipinden belirgin şekilde farklı davranan varyant */
  var KARSI_TIP = { 1: 'sp', 2: 'sp', 3: 'sp', 4: 'sp', 5: 'so', 6: 'sx', 7: 'sp', 8: 'so', 9: 'so' };

  /* Çemberde komşuluk — kanat hesabı için */
  function komsular(t) {
    return [t === 1 ? 9 : t - 1, t === 9 ? 1 : t + 1];
  }
  function grupBul(tablo, t) {
    for (var k in tablo) if (tablo[k].tipler.indexOf(t) > -1) return tablo[k];
    return null;
  }

  /* ---------------------------------------------------------- puanlama */

  /**
   * Ham tip puanlarını ipsatif z-skora çevirir.
   * ham: { 1..9 -> toplam puan }
   * Dönen z: kişinin kendi dağılımına göre standartlaştırılmış puanlar.
   */
  function zSkor(ham) {
    var t = [], i;
    for (i = 1; i <= 9; i++) t.push(ham[i] || 0);
    var ort = t.reduce(function (a, b) { return a + b; }, 0) / 9;
    var vary = t.reduce(function (a, b) { return a + (b - ort) * (b - ort); }, 0) / 9;
    var std = Math.sqrt(vary);
    var z = {};
    for (i = 1; i <= 9; i++) {
      /* std 0 ise (tüm cevaplar aynı) ayrım yok — hepsi 0 kabul edilir */
      z[i] = std > 0.0001 ? ((ham[i] || 0) - ort) / std : 0;
    }
    return { z: z, ort: ort, std: std };
  }

  /** z-skoru 0-100 arası okunur bir "eğilim" yüzdesine çevirir. */
  function yuzde(zv) {
    /* z ≈ -2..+2 aralığını 0..100'e taşır, uçları kırpar */
    return Math.max(0, Math.min(100, Math.round((zv + 2) / 4 * 100)));
  }

  /**
   * Kanat: ana tipin İKİ KOMŞUSUNDAN yüksek olanı.
   * Kanat yalnızca komşular arasından seçilir — Enneagram'da kanat tanımı budur;
   * uzaktaki yüksek bir tip kanat olamaz (o büyük ihtimalle ok ya da alt tip etkisi).
   */
  function kanatBul(anaTip, z) {
    var k = komsular(anaTip);
    var a = z[k[0]], b = z[k[1]];
    var kanat = a >= b ? k[0] : k[1];
    var digeri = a >= b ? k[1] : k[0];
    var fark = Math.abs(a - b);
    return {
      kanat: kanat,
      digerKanat: digeri,
      guc: fark < 0.35 ? 'dengeli' : (fark < 0.9 ? 'belirgin' : 'baskın'),
      fark: fark,
      etiket: anaTip + 'w' + kanat
    };
  }

  /**
   * İçgüdüsel yığın (instinctual stacking): sp / so / sx sıralaması.
   * ham3 = { sp: n, so: n, sx: n }
   */
  function icguduYigin(ham3) {
    var d = [
      { k: 'sp', v: ham3.sp || 0 },
      { k: 'so', v: ham3.so || 0 },
      { k: 'sx', v: ham3.sx || 0 }
    ].sort(function (a, b) { return b.v - a.v; });
    var toplam = d[0].v + d[1].v + d[2].v || 1;
    return {
      sira: d.map(function (x) { return x.k; }),
      baskin: d[0].k,
      ikincil: d[1].k,
      koru: d[2].k,
      oran: {
        sp: Math.round((ham3.sp || 0) / toplam * 100),
        so: Math.round((ham3.so || 0) / toplam * 100),
        sx: Math.round((ham3.sx || 0) / toplam * 100)
      },
      /* baskın ile ikincil çok yakınsa yığın net değildir */
      net: (d[0].v - d[1].v) >= Math.max(1, toplam * 0.06)
    };
  }

  /**
   * Sonucun ne kadar güvenilir olduğunu bildirir.
   * İlk iki tip birbirine çok yakınsa kullanıcıya dürüstçe söylenir.
   */
  function guvenSeviyesi(sirali) {
    var fark = sirali[0].z - sirali[1].z;
    if (fark >= 0.65) return { seviye: 'net',    fark: fark };
    if (fark >= 0.30) return { seviye: 'olasi',  fark: fark };
    return { seviye: 'belirsiz', fark: fark };
  }

  /**
   * Tam çözümleme.
   * ham    : { 1..9 -> tip ham puanı }
   * ham3   : { sp, so, sx }
   * saglik : 0-1 arası iyilik göstergesi (isteğe bağlı)
   */
  function coz(ham, ham3, saglik) {
    var n = zSkor(ham);
    var z = n.z;

    var sirali = [];
    for (var i = 1; i <= 9; i++) sirali.push({ tip: i, z: z[i], ham: ham[i] || 0, yuzde: yuzde(z[i]) });
    sirali.sort(function (a, b) { return b.z - a.z; });

    var ana = sirali[0].tip;
    var kanat = kanatBul(ana, z);
    var ig = icguduYigin(ham3 || {});
    var guven = guvenSeviyesi(sirali);

    return {
      anaTip: ana,
      sirali: sirali,
      z: z,
      kanat: kanat,
      merkez: grupBul(MERKEZ, ana),
      hornevian: grupBul(HORNEVIAN, ana),
      harmonik: grupBul(HARMONIK, ana),
      stresOk: STRES[ana],
      buyumeOk: BUYUME[ana],
      icgudu: ig,
      altTipKod: ig.baskin + ana,
      karsiTipMi: KARSI_TIP[ana] === ig.baskin,
      guven: guven,
      /* ikinci ve üçüncü aday — belirsizlikte kullanıcıya sunulur */
      adaylar: sirali.slice(0, 3).map(function (x) { return x.tip; }),
      saglik: typeof saglik === 'number' ? saglik : null
    };
  }

  g.ODTEnneagram = {
    coz: coz, zSkor: zSkor, yuzde: yuzde, kanatBul: kanatBul,
    icguduYigin: icguduYigin, komsular: komsular, grupBul: grupBul,
    STRES: STRES, BUYUME: BUYUME, MERKEZ: MERKEZ,
    HORNEVIAN: HORNEVIAN, HARMONIK: HARMONIK, KARSI_TIP: KARSI_TIP
  };
})(typeof window !== 'undefined' ? window : globalThis);
